import Cookies from "js-cookie";
import { i18n } from "@/i18n";

export const getTokenFromCookies = (): string | null | undefined => {
  return (
    Cookies.get("auth_token") ?? localStorage.getItem("auth_token") ?? undefined
  );
};

export const setTokenToCookies = (token: string): void => {
  try {
    Cookies.set("auth_token", token, {
      expires: 1,
      secure: true,
      sameSite: "lax",
      path: "/",
    });

    if (!Cookies.get("auth_token")) {
      localStorage.setItem("auth_token", token);
    }
  } catch {
    localStorage.setItem("auth_token", token);
  }
};

export const removeTokenFromCookies = (): void => {
  Cookies.remove("auth_token");
  if (localStorage.getItem("auth_token")) {
    localStorage.removeItem("auth_token");
  }
};
export const getPhoneNumber = (phoneString: string) => {
  return phoneString.replace(/\D/g, "");
};

export function setLocalStorageParams<T>(key: string, value: T): void {
  try {
    const serializedValue = JSON.stringify(value);
    localStorage.setItem(key, serializedValue);
  } catch (error) {
    console.error(
      i18n.global.t("common.errors.localStorageWrite", { key }),
      error
    );
  }
}

export function getLocalStorageParams<T>(
  key: string,
  defaultValue: T | null = null
): T | null {
  try {
    const storedValue = localStorage.getItem(key);

    if (storedValue === null) return defaultValue;

    return JSON.parse(storedValue) as T;
  } catch (error) {
    console.error(
      i18n.global.t("common.errors.localStorageRead", { key }),
      error
    );
    return defaultValue;
  }
}

export function getCurrentDate(): string {
  const today = new Date();
  const year = today.getFullYear();
  const month = String(today.getMonth() + 1).padStart(2, "0");
  const day = String(today.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
}

function subtractMonths(date: Date, months: number): Date {
  const newDate = new Date(date);
  const initialDay = date.getDate();
  newDate.setMonth(newDate.getMonth() - months);

  if (newDate.getDate() !== initialDay) {
    newDate.setDate(0);
  }
  return newDate;
}

export function getStartDate(period: string): string {
  const currentDate = new Date();
  let resultDate: Date;

  switch (period) {
    case "week":
      resultDate = new Date(currentDate);
      resultDate.setDate(resultDate.getDate() - 7);
      break;
    case "month":
      resultDate = subtractMonths(currentDate, 1);
      break;
    case "three-months":
      resultDate = subtractMonths(currentDate, 3);
      break;
    default:
      throw new Error(i18n.global.t("common.errors.invalidPeriod"));
  }

  const year = resultDate.getFullYear();
  const month = String(resultDate.getMonth() + 1).padStart(2, "0");
  const day = String(resultDate.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
}
